export default __webpack_public_path__ + "42095976d3e71e58536acda6bfadb09c.jpg";